<template>
  <div class="d-flex justify-content-between">
    <a @click="plusSlidesWebTab(-1)" style="font-size: x-large">❮</a>
    <h3
      style="
        color: #1481da !important;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      "
    >
      {{ currentLanguage.title_VimassPOStrenmaytinh }}
    </h3>
    <a @click="plusSlidesWebTab(1)" style="font-size: x-large">❯</a>
  </div>
  <div class="slideswebtabhow-container">
    <div
      v-for="(slide, index) in slideswebtab"
      :key="index"
      class="mySlidesWebTab container-fluid"
    >
      <div class="row">
        <div class="column col-12 m-auto">
          <div class="container-fluid" style="height: 110px">
            <div v-if="savedLanguage === 'vi' || !savedLanguage">
              <div
                v-html="slide.htmlContent"
                class="d-flex flex-column mt-3"
                style="
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                  line-height: 2;
                  text-align: start;
                  /* font-size: 16px */
                "
              ></div>
            </div>
            <div v-else-if="savedLanguage === 'en'">
              <div
                v-html="slide.htmlContentEn"
                class="d-flex flex-column mt-3"
                style="
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                  line-height: 2;
                  text-align: start;
                  /* font-size: 16px */
                "
              ></div>
            </div>
            <div v-else-if="savedLanguage === 'cn'">
              <div
                v-html="slide.htmlContentCn"
                class="d-flex flex-column mt-3"
                style="
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                  line-height: 2;
                  text-align: start;
                  /* font-size: 16px */
                "
              ></div>
            </div>
          </div>
        </div>
        <div
          class="column col-12 p-0"
          v-if="savedLanguage === 'vi' || !savedLanguage"
        >
          <img
            :src="slide.image"
            style="
              border: 5px solid rgb(152 154 156);
              border-radius: 15px;
              width: inherit;
              height: 615px;
            "
            class="hover-shadow cursor"
          />
        </div>
        <div
          class="column col-12 p-0"
          v-if="savedLanguage == 'en' || savedLanguage == 'cn'"
        >
          <img
            :src="slide.imageEn"
            style="
              border: 5px solid rgb(152 154 156);
              border-radius: 15px;
              width: inherit;
              height: 615px;
            "
            class="hover-shadow cursor"
          />
        </div>
        <!-- <div class="column col-12  m-auto">
            <div class="container-fluid">
              <div>
                <div
                  v-html="slide.htmlContent"
                  class="d-flex flex-column mt-3 "
                  style="
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    line-height: 2;
                text-align: start;
                font-size: 16px
                  "
                ></div>
              </div>
            </div>
          </div> -->
      </div>
    </div>

    <!-- <a class="prev" @click="plusSlidesWebTab(-1)">❮</a>
              <a class="next" @click="plusSlidesWebTab(1)">❯</a> -->
  </div>
</template>
    <script>
import { imageUrls, langBanner } from "@/components/js/urlImg";

import { languages } from "@/components/js/langVpos";
export default {
  data() {
    return {
      savedLanguage: "",
      currentLanguage: languages.vi,
      imageUrls: imageUrls,
      langBanner: langBanner.vi,
      slideIndex: 0,
      slideswebtab: [
        {
          image: langBanner.vi.imgWeb1,
          imageEn: langBanner.en.imgWeb1,

          tittle: "",
          htmlContent:
            "   <span style='left: 0px' >  <span style='font-weight: 600;'>" +
            languages.vi.titleDangKy +
            ":</span>" +
            languages.vi.contentDangKyWeb +
            "</span >" +
            "  <span style='left: 0px'    >  <span style='font-weight: 600;'>" +
            languages.vi.titleDangNhap +
            ":</span>" +
            languages.vi.contentDangNhapWeb +
            "</span>",
          htmlContentEn:
            "   <span style='left: 0px' >  <span style='font-weight: 600;'>" +
            languages.en.titleDangKy +
            ":</span>" +
            languages.en.contentDangKyWeb +
            "</span >" +
            "  <span style='left: 0px'    >  <span style='font-weight: 600;'>" +
            languages.en.titleDangNhap +
            ":</span>" +
            languages.en.contentDangNhapWeb +
            "</span>",
          htmlContentCn:
            "   <span style='left: 0px' >  <span style='font-weight: 600;'>" +
            languages.cn.titleDangKy +
            ":</span>" +
            languages.cn.contentDangKyWeb +
            "</span >" +
            "  <span style='left: 0px'    >  <span style='font-weight: 600;'>" +
            languages.cn.titleDangNhap +
            ":</span>" +
            languages.cn.contentDangNhapWeb +
            "</span>",
        },
        {
          image: langBanner.vi.imgWeb2,
          imageEn: langBanner.en.imgWeb2,

          tittle: "",

          htmlContent:
            "   <span style='left: 0px' ><span style='font-weight: 600;'>" +
            languages.vi.titleSanPham +
            ": </span> " +
            languages.vi.contentSanPhamWeb +
            "</span >" +
            "  <span style='left: 0px'    ><span style='font-weight: 600;'>" +
            languages.vi.titleThanhToan +
            ": </span>" +
            languages.vi.contentThanhToanWeb +
            "</span>",
          htmlContentEn:
            "   <span style='left: 0px' ><span style='font-weight: 600;'>" +
            languages.en.titleSanPham +
            ": </span> " +
            languages.en.contentSanPhamWeb +
            "</span >" +
            "  <span style='left: 0px'    ><span style='font-weight: 600;'>" +
            languages.en.titleThanhToan +
            ": </span>" +
            languages.en.contentThanhToanWeb +
            "</span>",
          htmlContentCn:
            "   <span style='left: 0px' ><span style='font-weight: 600;'>" +
            languages.cn.titleSanPham +
            ": </span> " +
            languages.cn.contentSanPhamWeb +
            "</span >" +
            "  <span style='left: 0px'    ><span style='font-weight: 600;'>" +
            languages.cn.titleThanhToan +
            ": </span>" +
            languages.cn.contentThanhToanWeb +
            "</span>",
        },
        {
          image: langBanner.vi.imgWeb3,
          imageEn: langBanner.en.imgWeb3,

          tittle: "",
          htmlContent:
            "   <span style='left: 0px' > <span style='font-weight: 600;'>" +
            languages.vi.titleTaoCuaHang +
            ": </span>" +
            languages.vi.contentTaoCuaHangWeb +
            "</span >" +
            "  <span style='left: 0px'    > <span style='font-weight: 600;'>" +
            languages.vi.titleThayDoiThongTin +
            ": </span>" +
            languages.vi.contentThayDoiThongTinWeb +
            "</span>",
          htmlContentEn:
            "   <span style='left: 0px' > <span style='font-weight: 600;'>" +
            languages.en.titleTaoCuaHang +
            ": </span>" +
            languages.en.contentTaoCuaHangWeb +
            "</span >" +
            "  <span style='left: 0px'    > <span style='font-weight: 600;'>" +
            languages.en.titleThayDoiThongTin +
            ": </span>" +
            languages.en.contentThayDoiThongTinWeb +
            "</span>",
          htmlContentCn:
            "   <span style='left: 0px' > <span style='font-weight: 600;'>" +
            languages.cn.titleTaoCuaHang +
            ": </span>" +
            languages.cn.contentTaoCuaHangWeb +
            "</span >" +
            "  <span style='left: 0px'    > <span style='font-weight: 600;'>" +
            languages.cn.titleThayDoiThongTin +
            ": </span>" +
            languages.cn.contentThayDoiThongTinWeb +
            "</span>",
        },

        {
          image: langBanner.vi.imgWeb4,
          imageEn: langBanner.en.imgWeb4,

          tittle: "",
          htmlContent:
            "   <span style='left: 0px' > <span style='font-weight: 600;'>" +
            languages.vi.titleSaoKe +
            ": </span> " +
            languages.vi.contentSaoKeWeb +
            "</span >" +
            "  <span style='left: 0px'    ><span style='font-weight: 600;'>" +
            languages.vi.titleTraCuu +
            ": </span>" +
            languages.vi.contentTraCuuWeb +
            "</span>",
          htmlContentEn:
            "   <span style='left: 0px' > <span style='font-weight: 600;'>" +
            languages.en.titleSaoKe +
            ": </span> " +
            languages.en.contentSaoKeWeb +
            "</span >" +
            "  <span style='left: 0px'    ><span style='font-weight: 600;'>" +
            languages.en.titleSaoKe +
            ": </span>" +
            languages.en.contentTraCuuWeb +
            "</span>",
          htmlContentCn:
            "   <span style='left: 0px' > <span style='font-weight: 600;'>" +
            languages.cn.titleSaoKe +
            ": </span> " +
            languages.cn.contentSaoKeWeb +
            "</span >" +
            "  <span style='left: 0px'    ><span style='font-weight: 600;'>" +
            languages.cn.titleSaoKe +
            ": </span>" +
            languages.cn.contentTraCuuWeb +
            "</span>",
        },
      ],
      autoSlideIntervalID: null,
    };
  },
  created() {
    this.savedLanguage = localStorage.getItem("languages");
    // const lang = this.$route.params.lang;
    if (languages[this.savedLanguage]) {
      this.currentLanguage = languages[this.savedLanguage];
    }

    if (this.savedLanguage && languages[this.savedLanguage]) {
      this.currentLanguage = languages[this.savedLanguage];
    }
  },
  mounted() {
    this.showSlidesWebTab(this.slideIndex);
    // this.startAutoSlidesWebTabhow();
  },
  methods: {
    startAutoSlidesWebTabhow() {
      setInterval(() => {
        this.plusSlidesWebTab(1);
      }, 15000);
    },

    plusSlidesWebTab(n) {
      this.showSlidesWebTab((this.slideIndex += n));
    },
    currentSlide(n) {
      this.showSlidesWebTab((this.slideIndex = n - 1));
    },

    showSlidesWebTab(n) {
      let i;
      const slideswebtab = document.getElementsByClassName("mySlidesWebTab");
      const dots = document.getElementsByClassName("dot");
      if (n >= slideswebtab.length) {
        this.slideIndex = 0;
      }
      if (n < 0) {
        this.slideIndex = slideswebtab.length - 1;
      }
      for (i = 0; i < slideswebtab.length; i++) {
        slideswebtab[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slideswebtab[this.slideIndex].style.display = "block";
      // dots[this.slideIndex].className += " active";
    },
  },
};
</script>
    <style scoped>
* {
  box-sizing: border-box;
}
body {
  font-family: Verdana, sans-serif;
  margin: 0;
}
.mySlidesWebTab {
  display: none;
}
img {
  vertical-align: middle;
}

/* SlidesWebTabhow container */
.slideswebtabhow-container {
  max-width: 1110px;
  /* position: relative; */
  margin: auto;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 10px;
  /* margin-top: -22px; */
  color: white;
  font-weight: bold;
  margin-right: 50%;
  margin-left: -50%;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: rgba(57, 148, 238, 0.8);
  border-radius: 10px;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
  border-radius: 10px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active,
.dot:hover {
  background-color: #717171;
}

/* Fading animation */

/* On smaller screens, decrease text size */
@media only screen and (max-width: 300px) {
  .prev,
  .next,
  .text {
    font-size: 11px;
  }
}
</style>